export const indexById = (id, array) => array.findIndex(e => e.id === id);



// WEBPACK FOOTER //
// ./src/reducers/indexById/indexById.js